<template>
    <!-- Main Wrapper -->
    <div v-if="payments?.length>0" >

      <div class="page-header">
          <div >
            <h5>
            Recorded Payments
            </h5>
          </div>
        </div>
      <div class="table-responsive">
                    <a-table
                      :columns="columns"
                      :data-source="payments"
                      :loading="isFetching"
                      :pagination="false"
                    >
                      <template #bodyCell="{ column, record, index }">
                        <template v-if="column.key === 'index'">
                          <span>{{ index + 1 }}</span>
                        </template>
                  
                        <template v-if="column.key === 'date'">
                          {{ record.date }}
                        </template>
                    
  
                        <template v-if="column.key === 'method'">
                       <span v-if="record.method === 'bank_transfer'">
                        Bank Transfer
                       </span>
                       <span v-else-if="record.method=== 'cash'">
                        Cash
                       </span>
                       <span v-else>
                        {{ record.method }}

                       </span>
                        </template>

                        <template v-if="column.key === 'amount'">
                          <span
                          >{{  record.currency.slice(0, 4) }}
                          {{ addCurrencyComma(record.amount) }}</span
                        >
                        </template>
                     
                      </template>
                    </a-table>
                  </div>
    </div>
  

    <!-- /Main Wrapper -->
  </template>
  <script setup>
  import { computed, ref, onMounted, watch } from "vue";
  import { formatted, formatDateToDashDigits } from "@/assets/composables/date";
  import { addCurrencyComma } from "@/assets/composables/currency";


  const isFetching = ref(false);

  const props = defineProps({
  payments: {
    type: Array,
    required: true
  }
});
  const columns = [
    {
      title: "#",
      key: "index",
      sorter: true,
    },
    {
      title: "Date",
      key: "date",
      sorter: true,
    },
    {
      title: "Amount",
      key: "amount",
      sorter: true,
    },
    {
      title: "Method",
      key: "method",
      sorter: true,
    },
  
  ];

  </script>
  